import { type ChainId, fallbackChainId } from '@/constants/chain-specific';
import type { RequiredFarmChainType } from '@/constants/project-specific';
import { FARM_PAGE_CONFIG } from '@/constants/project-specific/farms';
import { MASTERCHEFS_CONFIG } from '@/constants/project-specific/farms/masterchef';
import type { FarmConfig, MasterChefConfig } from '@/constants/project-specific/farms/types';
import type { Address, ContractFunctionParameters } from 'viem';

const farmSettings = FARM_PAGE_CONFIG

// match masterchef by slug
export function getMasterChefConfigBySlug(slug: string = farmSettings.fallbackMasterchefSlug, chainId: RequiredFarmChainType = farmSettings.defaultChain as RequiredFarmChainType): MasterChefConfig | undefined {
    return MASTERCHEFS_CONFIG[chainId].find((config) => config.slug === slug);
}

// return wagmi pending rewards call for a given farm
export function getPendingCall(farmConfig: FarmConfig, address: Address, chainId: RequiredFarmChainType = fallbackChainId): ContractFunctionParameters {

    const masterchef = getMasterChefConfigBySlug(farmConfig.masterChefSlug ?? farmSettings.fallbackMasterchefSlug, chainId) ?? farmSettings.defaultChef[fallbackChainId];

    const mcContract = {
        address: masterchef?.address,
        abi: masterchef?.abi,
    } as const;

    return {
        ...mcContract,
        functionName: masterchef?.pendingFunction,
        args: [farmConfig.pid, address],
    }
}

export function getPerBlockCall(farmConfig: FarmConfig, chainId: RequiredFarmChainType = fallbackChainId): ContractFunctionParameters {

    const masterchef = getMasterChefConfigBySlug(farmConfig.masterChefSlug ?? farmSettings.fallbackMasterchefSlug, chainId) ?? farmSettings.defaultChef[fallbackChainId];

    const mcContract = {
        address: masterchef?.address,
        abi: masterchef?.abi,
    } as const;

    return {
        ...mcContract,
        functionName: masterchef?.rewardPerBlockFunction,
    }
}
